import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, Button, Card, Col, Divider, Form, Input, Radio, Row, Modal } from 'antd';
import { Link } from 'react-router-dom';
import { AppWrappperHOC } from '../Root/HOC';
import { CALCULATE_BALANCE_YESBANK, NETWORKCARD_CONSTANTS } from '../NetworkCards/constants';
import { StyledYesBankZingerCard } from '../NetworkCards/StyledNetworkCard';
import { radioOptions } from './constants';
import { Container } from '../../components';
import { constants, utils, validationRules } from '../../devUtils';
import { OtpScreen } from '../NetworkCards/OtpScreen';
import { YesBankReplaceCardMapDispatchToProps, YesBankReplaceCardMapStateToProps, YesBankReplaceCardPropTypes } from './yesBankReplaceCardDataHandler';
import theme from '../../theme';

const { TextArea } = Input;
const { YES_BANK_CARD_REPLACEMENT } = NETWORKCARD_CONSTANTS;

class YesBankReplaceCard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalType: '',
      OTP: '',
      showResendText: false,
      remainingTime: 60,
      selectedRadioValue: '',
    };
    this.startTimer = this.startTimer.bind(this);
    this.verifyYesBankOtp = this.verifyYesBankOtp.bind(this);
    this.handleOTPChange = this.handleOTPChange.bind(this);
    this.handleResendYblOtp = this.handleResendYblOtp.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const {
      match: {
        params: {
          id = '',
        } = {},
      } = {},
      location,
      onFetchCardData,
    } = this.props;
    onFetchCardData(id, location);
  }

  componentWillReceiveProps(nextProps) {
    const {
      GetYesBankOtpSuccess, GetYesBankOtpSuccess: { status: yesBankOtpSuccessStatus = false },
      onSetChannelFlagSuccess,
      SetChannelFlagSuccess, SetChannelFlagSuccess: { status: channelFlagSuccessStatus = false },
      onFetchCardData,
      history,
      match: { params: { id: card_id = '' } = {} } = {},
      history: {
        location = {},
      } = {},
    } = nextProps;
    const {
      GetYesBankOtpSuccess: _GetYesBankOtpSuccess,
      SetChannelFlagSuccess: _SetChannelFlagSuccess,
    } = this.props;
    if (!utils.isEqual(GetYesBankOtpSuccess, _GetYesBankOtpSuccess) && yesBankOtpSuccessStatus) {
      this.setState({ modalType: 'YESBANK_OTP_SCREEN' });
      this.startTimer();
    } else if (!utils.isEqual(SetChannelFlagSuccess, _SetChannelFlagSuccess) && channelFlagSuccessStatus) {
      this.setState({ OTP: '', showResendText: false, remainingTime: 60, modalType: '' });
      onFetchCardData(card_id, location);
      onSetChannelFlagSuccess();
      clearInterval(this.timer);
      utils.forceRedirect(history, { pathname: history.goBack() });
    }
  }


  onRadioButtonChange(value) {
    this.setState({ selectedRadioValue: value });
  }

  sendOtp(type) {
    const {
      onGetOtp,
    } = this.props;
    onGetOtp({ otp_type: type });
  }

  handleOTPChange(OTP) {
    this.setState({ OTP });
  }

  handleModal(type) {
    this.setState({
      modalType: typeof (type) === 'string' ? type : '',
    });
  }


  handleResendYblOtp(type) {
    const {
      onGetOtp,
    } = this.props;
    clearInterval(this.timer);
    onGetOtp({ otp_type: type });
    this.setState({
      showResendText: false,
      remainingTime: 60,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const {
      form = {},
    } = this.props;

    form.validateFields((err) => {
      if (!err) {
        this.sendOtp(YES_BANK_CARD_REPLACEMENT);
      }
    });
  }


  verifyYesBankOtp(type) {
    const {
      CardDataYbl,
      onSetChannelFlag,
      form: {
        getFieldValue,
      } = {},
    } = this.props;
    const {
      cards: [
        {
          kit_number = '',
          card_type = '',
        } = {},
      ] = [],
    } = CardDataYbl;
    const {
      OTP,
      selectedRadioValue,
    } = this.state;
    const action_type = 'replace';
    const dispatchAddress = getFieldValue('dispatch_address');
    if (type === YES_BANK_CARD_REPLACEMENT) {
      onSetChannelFlag({
        reason: selectedRadioValue,
        kit_number,
        action_type,
        dispatch_address: dispatchAddress,
        otp: OTP,
      }, { cardType: card_type, type: 'ACTIONS' });
    }
  }

  startTimer() {
    this.timer = setInterval(() => {
      const { remainingTime } = this.state;
      if (remainingTime === 1) {
        clearInterval(this.timer);
        this.setState({ showResendText: true });
      }
      this.setState((prevState) => ({
        remainingTime: prevState.remainingTime - 1,
      }));
    }, 1000);
  }

  renderModalCloseFunction(modalType) {
    switch (modalType) {
      case 'YESBANK_OTP_SCREEN':
        return this.handleModal;
      default:
        return () => '';
    }
  }

  renderModalUI(modalType) {
    switch (modalType) {
      case 'YESBANK_OTP_SCREEN':
        return this.renderOtpScreen(YES_BANK_CARD_REPLACEMENT);
      default:
        return '';
    }
  }

  renderOtpScreen(type) {
    const {
      SelectUserDetails: {
        phone = '',
      } = {},
      isLoadingStatus = false,
    } = this.props;
    const {
      OTP,
      showResendText,
      remainingTime,
    } = this.state;
    return (
      <OtpScreen
        type={type}
        MobileNumber={phone}
        isLoadingStatus={isLoadingStatus}
        OTP={OTP}
        showResendText={showResendText}
        remainingTime={remainingTime}
        handleOTPChange={this.handleOTPChange}
        handleResendOtp={() => this.handleResendYblOtp(type)}
        verifyOTP={() => this.verifyYesBankOtp(type)}
      />
    );
  }

  renderCardImages(CardDataYbl) {
    let showImage = null;
    const {
      match: { params: { id } },
      CardDataYbl: {
        cards: [
          {
            expiry_month = '',
            expiry_year = '',
            card_status = '',
            code = '',
            name = '',
            cvv = '',
          } = {},
        ] = [],
      } = {},
    } = this.props;

    if (cvv) {
      showImage = (
        <Fragment>
          <input type="checkbox" id="CardClick" />
          <label className="card-containert" htmlFor="CardClick">
            <div className="card-flip">
              <div className={`side ${!['physical', 'virtual'].includes(id) ? '' : ''}`}>
                <h1 className="balance">
                  Rs. {CALCULATE_BALANCE_YESBANK(CardDataYbl)}
                </h1>
                <h3 className="card-name">
                  {name}
                </h3>
                <div className="footer">
                  <span className="font-14 pb-05">Card Number:</span> {code}<br />
                  <span className="font-14 pb-05">Expiry:</span> {expiry_month}/{expiry_year}<br />
                  <span className="font-14 pb-05">Card Status:</span> {card_status}<br />
                </div>
              </div>
              <div className="side back">
                <div className="card-details">
                  <span className="card-expiry">{expiry_month}/{expiry_year}</span>
                  <span className="card-cvv">{cvv}</span>
                </div>
              </div>
            </div>
          </label>
        </Fragment>
      );
    } else {
      showImage = (
        <div className="card-flip default">
          <div className={`side ${!['physical', 'virtual'].includes(id) ? 'default-user' : ''}`}>
            <h1 className="balance">Rs. {CALCULATE_BALANCE_YESBANK(CardDataYbl)}</h1>
            <h3 className="card-name">{name}</h3>
            <div className="footer">
              <Row align="middle" type="flex" gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <span className="font-12 pb-05">Card Number:</span> {code}<br />
                  {expiry_month ? <Fragment><span className="font-12 pb-05">Expiry:</span> {expiry_month}/{expiry_year}<br /></Fragment> : null}
                  <span className="font-12 pb-05">Card Status:</span> {card_status}<br />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      );
    }
    return (
      <Col xs={24} sm={24} md={10} lg={10} xl={10}>
        <StyledYesBankZingerCard>
          {showImage}
        </StyledYesBankZingerCard>
      </Col>
    );
  }

  renderFormDetails() {
    const {
      isLoadingStatus,
      history,
      form: {
        getFieldDecorator,
      } = {},
    } = this.props;
    const {
      selectedRadioValue,
    } = this.state;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Fragment>
          <h3>Reason for Replacing the Card <span style={{ fontSize: '20px', color: theme.hotRed }}>*   </span> :</h3>
          <Form.Item>
            {getFieldDecorator('reason_for_replacement', {
              rules: [{ required: true, message: 'Please select a reason!' }],
              initialValue: selectedRadioValue,
            })(
              <Radio.Group
                onChange={({ target: { value } }) => this.onRadioButtonChange(value)}
              >
                {radioOptions.map(({ value, label }) => (
                  <Radio
                    className="width-100 margin-t-1"
                    value={value}
                    key={value}
                  >
                    {label}
                  </Radio>
                ))}
              </Radio.Group>
            )}
          </Form.Item>
          <h3 className="margin-t-3">Address For Dispatch <span style={{ fontSize: '20px', color: theme.hotRed }}>*   </span>:</h3>
          <Form.Item className="margin-b-1">
            {getFieldDecorator('dispatch_address', {
              rules: [validationRules.mandatory],
            })(
              <TextArea rows={2} placeholder="Enter Your Address" />
            )}
          </Form.Item>
          <div className="text-left margin-t-2">
            <Button className="white-btn width-3" onClick={() => history.goBack()}>
              Cancel
            </Button>
            <Button
              htmlType="submit"
              className="green-btn margin-l-1 width-3"
              loading={isLoadingStatus}
            >
              Replace
            </Button>
          </div>
        </Fragment>
      </Form>
    );
  }

  render() {
    const {
      CardDataYbl = {},
    } = this.props;
    const {
      modalType,
    } = this.state;
    return (
      <div>
        <Fragment>
          <Modal
            visible={!!modalType}
            onCancel={this.renderModalCloseFunction(modalType)}
            size="sm"
            classname="default-popup"
            footer={null}
            maskClosable={false}
          >
            {modalType && this.renderModalUI(modalType)}
          </Modal>
          <br clear="all" />

          <Container className="margin-t-2">
            <Row align="top" type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-left">
                <h1 className="margin-b-1 font-20">Manage Zaggle Cards</h1>
                <Breadcrumb separator="<">
                  <Breadcrumb.Item><Link to={constants.LINK_MY_PROFILE}>My Account</Link></Breadcrumb.Item>
                  <Breadcrumb.Item><Link to={constants.LINK_PAY_BALANCE}>Manage cards</Link></Breadcrumb.Item>
                  <Breadcrumb.Item>Replace Card</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </Row>
            <Card className="rounded card-padding-20 noborder noshadow margin-t-2">
              <Row align="middle" type="flex" gutter={20}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <h2 className="font-18">Replace Card</h2>
                </Col>
              </Row>
              <Divider />
              <Row align="top" type="flex">
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  {this.renderCardImages(CardDataYbl)}
                </Col>
                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                  {this.renderFormDetails()}
                </Col>
              </Row>
              <Row align="top" type="flex" gutter={[15, 15]}>
              </Row>
            </Card>
          </Container>
        </Fragment>
      </div>
    );
  }
}


YesBankReplaceCard.propTypes = YesBankReplaceCardPropTypes;

const YesBankReplaceCardWrapper = Form.create({ name: 'normal_admin' })(YesBankReplaceCard);
export default connect(YesBankReplaceCardMapStateToProps, YesBankReplaceCardMapDispatchToProps)(AppWrappperHOC(YesBankReplaceCardWrapper));
export { YesBankReplaceCard, YesBankReplaceCardMapStateToProps, YesBankReplaceCardMapDispatchToProps, YesBankReplaceCardWrapper };



// WEBPACK FOOTER //
// client/containers/YesBankReplaceCard/index.js